export enum EditMode {
  EDIT_TEXT,
  EDIT_NOTES,
  EDIT_COLOR,
  EDIT_SHAPE
}
